module.exports = __webpack_public_path__ + "static/media/sortir.c514121e.webp";